import {
  clearFavorites,
  deleteFavorite,
  fetchFavorites,
  selectFavorites,
  selectFavoritesClearing,
  selectFavoritesError,
  selectFavoritesLoading,
  startClearingFavorites,
} from "../../../redux/slices/favoritesSlice";
import { useDispatch, useSelector } from "react-redux";

import { Helmet } from 'react-helmet';
import { IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";
import { Loader } from "../../Loader/Loader";
import { useTranslation } from "react-i18next";

const Favorites = () => {
  const dispatch = useDispatch();
  const favorites = useSelector(selectFavorites);
  const loading = useSelector(selectFavoritesLoading);
  const error = useSelector(selectFavoritesError);
  const clearing = useSelector(selectFavoritesClearing);
  const { categories, loading: categoryLoading } = useSelector(
    (state) => state.categories
  );
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";
  const handleRemoveItem = (productId) => {
    dispatch(deleteFavorite(productId));
  };

  const handleClearFavorites = () => {
    dispatch(startClearingFavorites());
    const removePromises = favorites.map((item) =>
      dispatch(deleteFavorite(item.id)).unwrap()
    );

    Promise.all(removePromises)
      .then(() => {
        dispatch(clearFavorites());
        console.log("Favorites cleared successfully");
      })
      .catch((error) => {
        console.error("Failed to clear some favorites:", error);
        dispatch(fetchFavorites());
      });
  };

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <Helmet>
        <title>
          {i18n.language === "en"
            ? `Spring Rose - زهرة الربيع - Profile - Addresses`
            : `حسابي - العناوين - زهرة الربيع -Spring Rose `}
        </title>
      </Helmet>
      <div className="flex flex-col items-center justify-center px-3 py-3 w-full">
        {loading || clearing ? (
          <div
            className=" flex justify-center items-center w-full 
    h-screen "
          >
            <Loader />
          </div>
        ) : !favorites?.length ? (
          <div
            className="flex w-full flex-col h-screen items-center 
          justify-center p-8 text-center"
          >
            <h1 className="text-2xl font-bold mb-4">{t("emptyFavoritesLabel")}</h1>
            <p className="mb-8">
              {t("emptyFavoritesText")}
            </p>
            <Link
              to="/products"
              className="bg-purble-2 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition"
            >
              {t("browseProducts")}
            </Link>
          </div>
        ) : (
          <div className="flex flex-col lg:flex-row gap-8 w-full ">
            {/* Cart Items */}
            <div className="flex flex-col w-full gap-2">
              {error && (
                <div className="w-full text-red-500 text-center py-4">
                  {typeof error === "object"
                    ? error.message || "Something went wrong"
                    : error}
                </div>
              )}
              <div
                className="lg:flex items-center justify-between bg-purble-2
                h-[59px] rounded-lg flex-shrink-0 hidden px-16 text-white"
              >
                <div>{t("productsNoun")}</div>
                <div
                  className=" flex items-center justify-end 
                 flex-shrink-0 w-1/2 gap-20 xl:gap-32"
                >
                  <div>{t("price")}</div> <div>{t("addToCart")}</div>
                </div>
              </div>
              <div
                className="w-full flex flex-col overflow-y-scroll
            lg:max-h-screen justify-start overflow-x-hidden"
              >
                {favorites.length > 0 &&
                  favorites.map((item) => {
                    const categoryId = item?.product?.category_id;
                    const category = categories.find(
                      (cat) => cat.id === categoryId
                    );
                    return (
                      <div
                        key={`${item.id}`}
                        className="flex w-full flex-col border-b"
                      >
                        <div
                          className="  py-4 mb-4 flex flex-col 
                    lg:flex-row items-center lg:items-start gap-4  w-full"
                        >
                          {/* Product Image */}
                          <div
                            className="flex items-center justify-start gap-3
                         w-full lg:w-full"
                          >
                            <button
                              onClick={() => handleRemoveItem(item?.id)}
                              className="text-black hover:text-red-500 hidden lg:flex"
                            >
                              <IoClose size={24} />
                            </button>
                            <div
                              className="w-[5.625rem] h-[5.625rem] rounded-2xl 
                          flex-shrink-0 cursor-pointer"
                            >
                              <img
                                src={`${item.product?.website_image}`}
                                alt={isEng ? item.product?.english_name : item.product?.arabic_name}
                                className="w-[5.625rem] h-[5.625rem] object-cover rounded-2xl"
                              />
                            </div>
                            <div
                              className="flex lg:w-full justify-between 
                          lg:justify-start w-full cursor-pointer"
                            >
                              <div
                                className="flex flex-col lg:flex-row lg:gap-10
                           justify-center lg:justify-between 
                          items-start lg:items-center h-[5.625rem] w-full"
                              >
                                <div>
                                  <h3 className="text-xl font-medium">
                                    {isEng ? item.product?.english_name : item.product?.arabic_name}
                                  </h3>
                                  <p className="text-lg text-gray-2">
                                    {!categoryLoading && isEng ? category?.english_name : category?.arabic_name}
                                  </p>
                                </div>
                                <div
                                  className="lg:w-1/2 flex items-center 
                                justify-between"
                                >
                                  <p className="text-lg text-black font-medium whitespace-nowrap">
                                    {item?.product?.price} {t("currency")}
                                  </p>
                                  <Link to={`/products/${item?.product?.id}`}>
                                    <button
                                      type="button"
                                      className="hidden lg:flex items-center justify-center text-lg bg-purble-2
                                   text-white hover:bg-blue-500 rounded-full w-[294px] 
                                   lg:w-[162px] h-[58px]"
                                    >
                                      {t("addToCart")}
                                    </button>
                                  </Link>
                                </div>
                              </div>
                              <button
                                onClick={() => handleRemoveItem(item?.id)}
                                className="text-black hover:text-red-500 
                              lg:hidden flex items-start"
                              >
                                <IoClose size={24} />
                              </button>
                            </div>
                          </div>
                          <Link to={`/products/${item?.product?.id}`}>
                            <button
                              type="button"
                              className="lg:hidden flex items-center justify-center text-lg bg-purble-2
                                   text-white hover:bg-blue-500 rounded-full w-full
                                   lg:w-[162px] h-[58px]"
                            >
                              {t("addToCart")}
                            </button>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div
                className="flex flex-col lg:flex-row items-center 
                justify-center lg:justify-end w-full px-3"
              >
                {/* <div className=" w-full flex-col flex">
                  <div className="flex flex-col lg:flex-row mb-2 w-full gap-3">
                    <input
                      type="text"
                      placeholder="Coupon code"
                      className="flex  px-4 border rounded-full w-full lg:w-[275px] 
                        h-[54px]"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                    />
                    <button
                      disabled={couponCode === ""}
                      className="bg-purble-2 hover:bg-blue-900 text-white 
                        px-4  w-full lg:w-[186px] h-[54px] text-lg
                      rounded-full"
                      onClick={handleApplyCoupon}
                    >
                      Apply Coupon
                    </button>
                  </div>
                  {couponError && (
                    <p className="text-red-500 text-sm">{couponError}</p>
                  )}
                </div> */}
                <button
                  type="button"
                  onClick={handleClearFavorites}
                  className=" text-right underline underline-offset-2 
                    text-blue-2 hover:text-red-500 flex-shrink-0 flex items-center
                    justify-center h-[54px]"
                >
                  {t("clearFavorites")}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default Favorites;
